/** Identifies a pipe-document `details` row as a Factory Acceptance (FAT) checklist template (not spool run data). */
export const FAT_CHECKLIST_SPEC_CATEGORY = 'FAT_CHECKLIST_TEMPLATE';

/** Shown in forms; API category is `FAT_CHECKLIST_SPEC_CATEGORY`. */
export const FAT_CHECKLIST_SPEC_LABEL = 'FAT checklist (factory acceptance)';
